import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { snackbar } from '@flipster/react/design-system/snackbar';
import QuestionCircleIcon from '@flipster/react/icon/generated/QuestionCircleIcon';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { flex } from '@flipster/styled-system/patterns/flex';
import { token } from '@flipster/styled-system/tokens';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { symbolBunja } from '../bunja/base';
import { formBunja } from '../bunja/form';
import LimitPriceForm from './LimitPriceFrom';

const LimitTypeForm = () => {
  const transTrade = useTranslations('Trade.r251104');
  const transTpsl = useTranslations('Trade.r260318');
  const { isBboAtom, resetLimitPrice, tpSlAtom } = useBunja(formBunja);
  const { symbol } = useBunja(symbolBunja);
  const [isBbo, setIsBbo] = useAtom(isBboAtom);
  const { enabled: isTpslEnabled } = useAtomValue(tpSlAtom);
  const isBboDisabled = isTpslEnabled;

  return (
    <div className={vstack({ w: '100%', gap: 16, py: 16 })}>
      <div className={flex({ w: '100%', justify: 'space-between' })}>
        <div className={css({ textStyle: 'Text/L/Strong' })}>{transTrade('Limit_price')}</div>
        <div
          onClick={() => {
            if (isBboDisabled) snackbar.error({ message: transTpsl('Bbo_disabled_description') });
          }}
        >
          <Checkbox
            checked={isBbo}
            disabled={isBboDisabled}
            onChange={(e) => {
              setIsBbo(e.target.checked);
              if (!e.target.checked) resetLimitPrice();
              segment.track(TradeEvent.OrderBboClick, { symbol, checkbox_click: e.target.checked });
            }}
          >
            <div className={css({ display: 'flex', gap: 4, alignItems: 'center', textStyle: 'Text/L/Strong' })}>
              BBO
              {!isBboDisabled && (
                <Tooltip placement='bottom-end' shape='white' maxWidth={238}>
                  <Tooltip.Trigger css={{ h: 16 }}>
                    <QuestionCircleIcon size={16} color={token('colors.content.default.level-2')} />
                  </Tooltip.Trigger>
                  <Tooltip.Content>
                    <h6 className={css({ textStyle: 'Text/S/Strong' })}>{transTrade('What_s_bbo')}</h6>
                    <p className={css({ textStyle: 'Text/S/Regular' })}>
                      {transTrade('Limit_price_follows_best_ask_bid_when_buying_selling')}
                    </p>
                  </Tooltip.Content>
                </Tooltip>
              )}
            </div>
          </Checkbox>
        </div>
      </div>
      <LimitPriceForm />
    </div>
  );
};

export default LimitTypeForm;
